import styled from "styled-components";
import {makeStyles} from "@material-ui/core";

export const FilterWrapper = styled.div`
    /* width: 400px; */
    height: 100vh;
    margin: 0 15px;
    /* border-radius: 15px; */
    z-index: 9999999;
    font-family: "SF-Pro" !important;
`;

export const AccordionWrapper = styled.div`
    width: 350px;
    height: 100vh;
    position: sticky;
    padding: 10px;
    background-color: #fff;
    top: 0px;
    font-family: "SF-Pro" !important;

    .btn_filter_wrapper {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 8px;
        padding: 20px;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid #e4e4e4;

        .btn_filter {
            display: inline;
            flex: 1;
            background-color: #9cc54b;
            color: #fff;
        }

        .clear_filter_btn {
            background: #4a4a49;
        }
    }

    @media (max-width: 600px) {
        width: 350px;
    }
    @media (min-width: 800px) {
        width: 400px;
    }

    @media (min-width: 1020px) {
        width: 400px;
    }
    @media (min-width: 1280px) {
        width: 400px;
    }
    @media (min-width: 1920px) {
        width: 500px;
    }
    /* margin: 0 10px; */

    .close {
        font-weight: bold;
        cursor: pointer;

        &:hover {
            color: red;
        }
    }

    /* overflow: scroll; */

    .body {
        height: 80%;
        padding: 0 8px;
        overflow-y: auto;

        ::-webkit-scrollbar {
            width: 5px;
            height: 5px;
        }

        ::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 20px;

        }

        /* Color for the scrollbar thumb */

        ::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 20px;
        }

        /* Color on hover for the scrollbar thumb */

        ::-webkit-scrollbar-thumb:hover {
            background: #555;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        /* background-color: red; */
    }

    .range-input-container {
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .range-input {
        width: 100%;
        margin-right: 1rem;
        -webkit-appearance: none;
        height: 6px;
        border-radius: 6px;
        background: #d3d3d3;
        outline: none;
        opacity: 0.7;
        -webkit-transition: .2s;
        transition: opacity .2s;
    }

    .range-input::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        /* color: rgb(156, 197, 75); */
        background: rgb(156, 197, 75);
        cursor: pointer;

    }

    .range-input::-moz-range-thumb {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: rgb(156, 197, 75);
        cursor: pointer;
    }

    .range-value-container {
        display: flex;
        text-align: center;
        justify-content: space-between;
        align-items: center;
        font-family: Arial, sans-serif;
        font-size: 14px;
        color: #666;
        margin-top: 10px;
    }

    /* .range-min,
		.range-max {
			font-weight: bold;
		}
		
		.range-value {
			padding: 0 0.5rem;
			background-color: #4CAF50;
			color: white;
			border-radius: 5px;
			margin: 0 5px;
			width: 50px;
			max-width: 50px;
		} */

`;

export const AccordionContainer = styled.div`
    /* border: 1px solid #e6e6e6; */
    // border-radius: 5px;
    // margin-bottom: 10px;
    /* box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1); */
    border-bottom: 1px solid #e4e4e4;
    font-family: "SF-Pro" !important;
    /* overflow: hidden; */
    /* overflow-y: auto; */

    &:last-child {
        border: none;
    }
`;

export const AccordionHeader = styled.div`
    align-items: center;
    /* background-color: #f5f5f5; */
    color: rgb(156, 197, 75);
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 700;
    padding: 12px 8px;
    position: relative;
    font-family: "SF-Pro" !important;

    &::after {
        content: '';
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s ease;
    }

    .react-switch {
        &.active {
            .react-switch-bg {
                background: #9cc54b !important;
            }
        }
    }

    ${({isOpen}) =>
            isOpen &&
            `
    &::after {
      transform: translateY(-50%) rotate(180deg);
    }
  `}
`;

export const AccordionTitle = styled.h6`
    margin: 0;
    font-size: 20px !important;
    font-family: "SF-Pro" !important;
    font-weight: 500;
    @media (min-width: 800px) {
        font-size: 22px;
    }
`;

export const AccordionContent = styled.div`
    padding: 0 8px 20px 8px;
    font-family: "SF-Pro" !important;

    .list_item {
        display: flex;
        flex-direction: column;
    }

    .form-group {
        margin-bottom: 0;
    }

    .item {
        width: fit-content;
        display: flex;
        justify-content: space-between;
        // margin: 0 5px;
        transition: all 0.2s ease;

        &:hover {
            font-weight: 600;
        }

        .form-check {
            gap: 10px;

            .form-check-input {
                width: 1rem;
                height: 1rem;
                margin-right: 0;
                cursor: pointer;
            }

            .form-check-label {
                cursor: pointer;
            }
        }
    }

    .item_value {
        background-color: rgb(156, 197, 75);
        padding: 2px 5px;
        font-size: 12px;
        border-radius: 5px;
        color: #FFF;
    }

    .react-switch {
        &.active {
            .react-switch-bg {
                background: #9cc54b !important;
            }
        }
    }
`;

export const useStyles = makeStyles((theme) => ({
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: theme.spacing(2),
		borderBottom: `1px solid ${theme.palette.divider}`,
		animation: '$slideInDown 0.4s ease-out',
	},
	headerTitle: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1),
	},
	body: {
		padding: theme.spacing(2),
		maxHeight: 'calc(100vh - 200px)',
		overflowY: 'auto',
		'&::-webkit-scrollbar': {
			width: '8px',
		},
		'&::-webkit-scrollbar-track': {
			background: '#f1f1f1',
		},
		'&::-webkit-scrollbar-thumb': {
			background: '#888',
			borderRadius: '4px',
			transition: 'background 0.3s ease',
		},
		'&::-webkit-scrollbar-thumb:hover': {
			background: '#555',
		},
	},
	accordionItem: {
		transition: 'all 0.3s ease',
		'&:hover': {
			backgroundColor: 'rgba(156, 197, 75, 0.02)',
		},
	},
	accordionIcon: {
		transition: 'transform 0.3s ease',
	},
	accordionIconRotate: {
		transform: 'rotate(180deg)',
	},
	checkboxLabel: {
		marginBottom: 0,
		transition: 'all 0.2s ease',
		'& .MuiFormControlLabel-label': {
			fontSize: '14px',
			marginBottom: 0,
			transition: 'all 0.2s ease',
		},
		'& label': {
			marginBottom: 0
		},
		'&:hover': {
			'& .MuiFormControlLabel-label': {
				color: '#9cc54b',
				fontWeight: 500,
			},
		},
	},
	checkboxRoot: {
		transition: 'all 0.2s ease',
		'&:hover': {
			transform: 'scale(1.1)',
		},
	},
	footer: {
		display: 'flex',
		gap: theme.spacing(2),
		padding: theme.spacing(2),
		borderTop: `1px solid ${theme.palette.divider}`,
		backgroundColor: theme.palette.background.paper,
		animation: '$slideInUp 0.4s ease-out',
	},
	clearButton: {
		flex: 1,
		color: theme.palette.text.secondary,
		borderColor: theme.palette.divider,
		transition: 'all 0.3s ease',
		'&:hover': {
			borderColor: '#9cc54b',
			color: '#9cc54b',
			transform: 'translateY(-2px)',
			boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
		},
		'&:active': {
			transform: 'translateY(0)',
		},
	},
	applyButton: {
		flex: 1,
		backgroundColor: '#9cc54b',
		color: theme.palette.common.white,
		transition: 'all 0.3s ease',
		'&:hover': {
			backgroundColor: '#8ab43f',
			transform: 'translateY(-2px)',
			boxShadow: '0 4px 12px rgba(156, 197, 75, 0.3)',
		},
		'&:active': {
			transform: 'translateY(0)',
		},
	},
	priceInputs: {
		display: 'flex',
		gap: theme.spacing(2),
		marginTop: theme.spacing(2),
	},
	priceInput: {
		flex: 1,
		'& .MuiOutlinedInput-root': {
			transition: 'all 0.3s ease',
			'&:hover': {
				'& .MuiOutlinedInput-notchedOutline': {
					borderColor: '#9cc54b',
				},
			},
			'&.Mui-focused': {
				'& .MuiOutlinedInput-notchedOutline': {
					borderColor: '#9cc54b',
				},
			},
		},
	},
	switchContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: theme.spacing(1, 0),
	},
	activeFiltersChip: {
		margin: theme.spacing(0.5),
		animation: '$bounce 0.6s ease',
		transition: 'all 0.3s ease',
		'&:hover': {
			transform: 'scale(1.1)',
		},
	},
	countryFlag: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1),
		transition: 'all 0.2s ease',
	},
	seeMoreButton: {
		marginTop: theme.spacing(1),
		padding: theme.spacing(0.5, 1),
		fontSize: '12px',
		textTransform: 'none',
		color: '#9cc54b',
		transition: 'all 0.3s ease',
		'&:hover': {
			backgroundColor: 'rgba(156, 197, 75, 0.08)',
			transform: 'translateX(4px)',
		},
	},
	filterItem: {
		animation: '$fadeInUp 0.3s ease-out',
	},
	// Keyframe animations
	'@keyframes slideInDown': {
		'0%': {
			transform: 'translateY(-20px)',
			opacity: 0,
		},
		'100%': {
			transform: 'translateY(0)',
			opacity: 1,
		},
	},
	'@keyframes slideInUp': {
		'0%': {
			transform: 'translateY(20px)',
			opacity: 0,
		},
		'100%': {
			transform: 'translateY(0)',
			opacity: 1,
		},
	},
	'@keyframes fadeInUp': {
		'0%': {
			transform: 'translateY(10px)',
			opacity: 0,
		},
		'100%': {
			transform: 'translateY(0)',
			opacity: 1,
		},
	},
	'@keyframes bounce': {
		'0%, 100%': {
			transform: 'scale(1)',
		},
		'50%': {
			transform: 'scale(1.2)',
		},
	},
}));